import gql from 'graphql-tag'
import { mapMutations, mapGetters } from 'vuex'

const cedulaUYValidate = {
    computed: {
		...mapGetters(['isAuthenticated'])
	},
	methods:{
        ...mapMutations(['setCommingVideochat']),
        searchCommingVideochat(){
            // console.log('searchCommingVideochat')
			if( this.isAuthenticated){
				this.$apollo.query({
					query: gql`query getVideocalls($commingVideocall: Boolean){
						me {
							bookings(commingVideocall:$commingVideocall){
								id
								code
								videocall_started_at
								status
								timeslot{
									datetime
								}
							}
						}
					}`,
					fetchPolicy: 'no-cache',
					variables:{
						commingVideocall: true
					}
				})
				.then((data) => {
					if(data.data.me.bookings.length>0){
						this.setCommingVideochat(data.data.me.bookings[0]);
					}else{
						this.setCommingVideochat(null);
                    }
				});
			}
		},
	}
}

export default cedulaUYValidate